// Initialize Sentry before anything else
import "./instrument";
import "./index.css";

import * as Sentry from "@sentry/react";

import App from "./App.tsx";
import { AuthKitProvider } from "@workos-inc/authkit-react";
import { DarkModeProvider } from "@/shared/hooks/useDarkMode";
import { StrictMode } from "react";
import { Toaster } from "react-hot-toast";
import { createRoot } from "react-dom/client";

const clientId = import.meta.env.VITE_WORKOS_CLIENT_ID;

// Fallback UI when React crashes
function ErrorFallback() {
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				height: "100vh",
				padding: "20px",
				textAlign: "center",
				fontFamily: "system-ui, sans-serif",
			}}
		>
			<h1 style={{ marginBottom: "16px" }}>Something went wrong</h1>
			<p style={{ marginBottom: "24px", color: "#666" }}>
				Our team has been notified. Please try refreshing the page.
			</p>
			<button
				onClick={() => window.location.reload()}
				style={{
					padding: "12px 24px",
					fontSize: "16px",
					cursor: "pointer",
					backgroundColor: "#000",
					color: "#fff",
					border: "none",
					borderRadius: "6px",
				}}
			>
				Refresh Page
			</button>
		</div>
	);
}

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<AuthKitProvider clientId={clientId} redirectUri={window.location.origin}>
			<Toaster />
			<DarkModeProvider>
				<Sentry.ErrorBoundary fallback={<ErrorFallback />} showDialog>
					<App />
				</Sentry.ErrorBoundary>
			</DarkModeProvider>
		</AuthKitProvider>
	</StrictMode>,
);

// UNREGISTER any existing service workers - they were causing blank page issues
// by serving stale cached content that never updated after deployments.
if ("serviceWorker" in navigator) {
	navigator.serviceWorker.getRegistrations().then((registrations) => {
		for (const registration of registrations) {
			registration.unregister().then((success) => {
				if (success) {
					console.log("Service worker unregistered successfully");
				}
			});
		}
	});
}
